import React, { useState } from "react";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { message, Upload, Row, Col } from "antd";
import Resizer from "react-image-file-resizer";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../../../store/user/user.selector";
import { updateUserInfo } from "../../../store/user/user.action";

const UserAvatar = (props) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  const avatar = user?.avatar;
  // -------------------------- FUNCTION --------------------------

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const handleUpload = (action) => {
    const file = action.file;
    setLoading(true);
    Resizer.imageFileResizer(
      file,
      512,
      512,
      "jpg",
      96,
      0,
      (uri) => {
        updateAvatar(uri);
      },
      "base64"
    );
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- DATA FUNCTION --------------------------

  const updateAvatar = (avatar) => {
    const update = { avatar };
    dispatch(
      updateUserInfo({ update }, (response) => {
        setLoading(false);
        if (response?.status === 200) {
          message.success("Update Avatar successfully!");
        }
        if (response?.status === 500) {
          message.error(response?.data || "Failed");
        }
      })
    );
  };

  // -------------------------- RENDER --------------------------

  const renderAvatar = () => {
    return (
      <img
        src={avatar}
        alt="avatar"
        style={{
          width: "100%",
        }}
      />
    );
  };

  const renderButton = () => {
    return (
      <div>
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Avatar</div>
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row gutter={[16, 16]} justify="center" align="center" style={{ marginBottom: 10 }}>
      <Col>
        <Upload
          name="avatar"
          listType="picture-card"
          className="avatar-uploader"
          showUploadList={false}
          disabled={loading}
          beforeUpload={beforeUpload}
          customRequest={handleUpload}
        >
          {avatar ? renderAvatar() : renderButton()}
        </Upload>
      </Col>
    </Row>
  );
};

export default UserAvatar;
